<template>
  <div class="background">
    <div class="login">
      <div class="login__logo">
        <img src="../assets/Icons/SG-logo2.svg" alt="logo error" />
      </div>
      <!-- <p class="login__paragraph">Log in to your account  <span>{{ takeResults.length }}</span> </p>  -->

      <h5
        class="login__h5 login__h5--userName "
        :class="{ hiddenLabel: !UserameLabel }"
      >
        Username
      </h5>
      <input
        type="username"
        name=""
        id="userName"
        v-model="username"
        placeholder="Username"
      />

      <h5
        class="login__h5 login__h5--password"
        :class="{ hiddenLabel: !PasswordLabel }"
      >
        Password
      </h5>

      <input
        :type="passowrdType"
        name="password"
        id="password"
        v-model="password"
        placeholder="Password"
      />
      <div class="chechBox_div">
        <input id="checkbox" type="checkbox" @click="showPassoword" />
        <p>Show Password</p>
      </div>

      <p class="login__message" :class="{ hiddenLabel: inputsValid }">
        Wrong credentials
        <br />
        <!-- FIXME: add smartgoals email -->
        <a
          class="login__message"
          :class="{ hiddenLabel: inputsValid }"
          href="mailto:ahmato.atoo@gmail.com"
          >Contact with Administrator</a
        >
      </p>
      <button
        class="login__btn"
        :class="{ btnActive: validInputs }"
        @click="onSubmit"
      >
        login
      </button>
    </div>
    <!-- <button class="login__btn--showMessage" @click="showPassoword" >Do you forget your data?</button> -->

    <div class="background__logos">
      <img
        class="background__logo-SG"
        src="../assets/Icons/smartGoals.png"
        alt="Smart goals"
      />
      <img
        class="background__logo-R"
        src="../assets/Icons/Rotterdam.png"
        alt="Rotterdam"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isAuth: this.$store.state.isAuthenticated,
      username: "",
      password: "",
      passowrdType: "password",
      message: "",
      inputsValid: true
    };
  },

  methods: {
    async onSubmit() {
      const formData = { username: this.username, password: this.password };

      await this.$store.dispatch("logIn", {
        username: this.username,
        password: this.password
      });

      if (this.isAuthenticated) {
        this.$router.replace({ path: "/home" }).catch(() => {});
      } else if (
        this.username === "" ||
        this.password.length < 8 ||
        !this.isAuthenticated
      ) {
        this.message = "Wrong credentials";
        this.inputsValid = false;
        return;
      }
      return formData;
    },
    showPassoword() {
      if (this.passowrdType === "password") this.passowrdType = "text";
      else this.passowrdType = "password";
    }
  },
  mounted() {},

  computed: {
    ...mapGetters(["takeResults", "isAuthenticated", "takeCategories"]),

    imgsrc: function() {
      return require("../assets/Icons/icon1.png");
    },

    validInputs() {
      if (
        !this.username &&
        this.username.length === 0 &&
        !this.password &&
        this.password.length === 0
      )
        return false;
      else return true;
    },
    UserameLabel() {
      if (this.username != "") return true;
      else return false;
    },
    PasswordLabel() {
      if (this.password != "") return true;
      else return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.chechBox_div {
  display: flex;
  margin: 5px 5px 0 0;

  #checkbox {
    float: left;
    width: 13px;
  }
  p {
    font-size: 12px;
    margin: 5px 0 0 5px;
  }
}

.login i {
  margin-left: -30px;
  cursor: pointer;
}

.background * {
  background: transparent;
}

.background {
  margin: 0;
  height: 100vh;
  background: url("../assets/Icons/login3.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  // background-color: greenyellow;
  //padding: 216px 677px 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &__p {
    width: 218px;
    height: 25px;
    border: transparent;
    opacity: 0.8;
    margin: 19px 50%;
  }
  &__logos {
    width: 566px;
    height: 66px;
    position: absolute;
    bottom: 0;
    // margin: 0 0 0 20px ;
    // text-align: center;
    opacity: 1;
  }
  &__logo-SG {
    width: 280px;
    height: 60px;
    padding: 20px 0 10px 0;
    float: left;
  }
  &__logo-R {
    width: 280px;
    height: 60px;
    float: right;
  }
}
.login {
  // margin: 243px auto 0 ;
  margin: 0 auto;
  // background-color: red;
  height: 580px;
  width: 566px;
  // backdrop-filter: blur(50px);
  background-color: rgba(4, 13, 9, 0.4);
  padding: 68px 103px 60px;

  &__logo {
    height: 80px;
    width: 307px;
    margin: 0 auto 60px;
    // opacity: 1;
  }

  &__paragraph {
    text-align: left;
    width: 300px;
  }
  &__message {
    margin: 30px 0 0 0;
    text-align: center;
    font-size: 14px;
    color: red;
    font-weight: 600;
  }

  &__btn {
    height: 40px;
    width: 360px;
    margin: 48px 0 0 0;
    padding: 11px 156.5px 12px 157.5px;
    background-color: #8b8b8b;
    opacity: 1;
  }
  .btnActive {
    // background-color: linear-gradient(266deg, #d68628 177%, #ff8a00 -45%);
    background-color: #d68628;
  }
}
.pic {
  height: 15px;
  width: 15px;
  background-image: url("../assets/Icons/eyeIcon.jpg");
  background-color: transparent;
  display: inline;
  float: right;
  margin: 9px 0 0 0;
}
#password {
  display: inline;

  // width: 345px;
  width: 360px;
}

img {
  height: 80px;
  width: 307px;
}
input {
  display: block;
  width: 360px;
  height: 24px;
  // margin: 40px 0 0 0;
  // border: transparent;
  border: none;
  border-bottom: solid 1px #afafaf;
  background-color: transparent;
}
// input[type="userName"]:focus {
//   background-color: blue;
//   outline: none;
// }
input:focus {
  outline-offset: 0px;
  //  background-color: red;
  outline: none;
}
input::placeholder {
  color: #ffffff;
}
span {
  color: red;
}

.login__h5 {
  font-family: Montserrat-Regular;
  font-size: 12px;

  &--userName {
    margin: 35px 0 0 0;
  }
  &--password {
    margin: 35px 0 0 0;
  }
}
.hiddenLabel {
  visibility: hidden;
}
</style>
